import SlideScroll from './util/slide-scroll';
import ChtSelect from './util/cht-select';
import movieInfo from './util/movie-info';

new nc.promokit.Preloader({
    'game': 'lineage',
    'delay': 600,
    'image': [
        '/promo/lineage/event/2020/200129_project/img/intro/copyright.png',
        '/promo/lineage/event/2020/200129_project/img/intro/header-bg.jpg',
        '/promo/lineage/event/2020/200129_project/img/intro/sec-bg.jpg',
        '/promo/lineage/event/2020/200129_project/img/intro/etc-menu-bg.png',
        '/promo/lineage/event/2020/200129_project/img/intro/main-tit.png',
        '/promo/lineage/event/2020/200129_project/img/intro/main-stit1.png',
        '/promo/lineage/event/2020/200129_project/img/intro/main-stit2.png',
        '/promo/lineage/event/2020/200129_project/img/intro/main-tit-shadow.png',
        '/promo/lineage/event/2020/200129_project/img/intro/main-thumb.png',
        '/promo/lineage/event/2020/200129_project/img/intro/other-bg.png',
        '/promo/lineage/event/2020/200129_project/img/intro/btn-back.png',
        '/promo/lineage/event/2020/200129_project/img/intro/sec1-con1-bg.png',
        '/promo/lineage/event/2020/200129_project/img/intro/layer-reward.jpg'
    ]
});

$(document).on('preloadend', function(){
    setTimeout(()=>{
        const slidescroll = new SlideScroll({
            el:"#container"
        });
    }, 450);

    $("#container").css({opacity:1});
});

const chtselect = new ChtSelect({
    el:".p-main",
    scale:1.1,
    leftX:-50,
    rightX:50
});

// $(document).on("click", "[data-movie]", function(){
//     alert("영상은 잠시 후 공개됩니다.");
// });

let movie = {}, layer = {}, close, nowPlay = {};

movieInfo.forEach( (obj, idx)=>{
    movie[obj.name] = new nc.promokit.Player({
        selector:obj.el,
        videoId:obj.url,
        mute:false,
        controls:true,
        coverClick:true
    });

    layer[obj.name] = new nc.promokit.Layer({
        el:obj.layer,
        fade:true,
        // esc:true,
        // dim:true,
        // dimClickClose:true
    });

    movie[obj.name].on("canplay", ()=>{
        nowPlay[obj.name] = true;
    });
});

$(document).on("click", "[data-movie]", function(){
    let name = $(this).data("movie");
    if(nowPlay[name]==undefined) return false;
    movie[name].play();
    layer[name].open();
    close = name;
    return false;
});

$("[data-close]").on("click", function(){
    if(movie[close]){
        movie[close].pause();
        layer[close].close();
    }
});


// WEBPACK FOOTER //
// ./src/js/intro.js